import React, { Component } from 'react';
import '../css/Descripcion.css';
import modulo from '../img/modulos.png';
class Descripcion extends Component {
  render() {
    return (
      <div className="fondo-descripcion" id="descripcionfondosistema">
        <div>
          <div className="cuadro-sistema">
            <h2 className="titulo-sistema">SIIA ERP</h2>
          </div>
          <div className="contenedor-sistema">
            <div className="caja-sistema1">
              <img className="img-modulo-sistema" src={modulo}></img>
            </div>
            <div className="cuadro-sistema1">
              <div className="cuadro-modulo1">
                <i className="glyphicon glyphicon-lock" id="icono-color"></i>
                <p className="parrafo-modulo1">Rápido y Seguro</p>
                <p className="parrafo-modulo2">Herramientas de Procesos Informáticos</p>
                <p className="parrafo-modulo3">que le permiten un sistema seguro</p>
              </div>
              <div className="cuadro-modulo2">
                <i className="glyphicon glyphicon-check" id="icono-color2"></i>
                <p className="parrafo-modulo4">Sistema de Fácil Manejo</p>
                <p className="parrafo-modulo5">Le Permitirá controlar</p>
                <p className="parrafo-modulo6">y mejorar los recursos de su empresa</p>
              </div>
            </div>
            <div className="cuadro-sistema2">
              <div className="cuadro-modulo3">
                <i className="glyphicon glyphicon-ok-sign" id="icono-color3"></i>
                <p className="parrafo-modulo7" style={{ fontWeight: '700' }}>Adaptable</p>
                <p className="parrafo-modulo8" style={{ margin: '0' }}>Diseñado a la medida  de sus requerimientos</p>
                <p className="parrafo-modulo9" style={{ margin: '0' }}>Centrados en el crecimiento de la empresa</p>
              </div>
              <div className="cuadro-modulo4">
                <i className="glyphicon glyphicon-tasks" id="icono-color4"></i>
                <p className="parrafo-modulo10">Servicio Integral Contable</p>
                <p className="parrafo-modulo11">Soporte al SIIA ERP en niveles contable y sistemas.</p>
                <p className="parrafo-modulo11">Servicio de backup semanal.</p>
                <p className="parrafo-modulo12">Presentación de libros electrónicos alineados a SUNAT</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Descripcion;


// WEBPACK FOOTER //
// ./src/components/Descripcion.jsx